import React, { useEffect, useState, useCallback } from 'react'; // Added useCallback
import { useSearchParams, useNavigate } from 'react-router-dom';
import './PaymentStatusPage.css';
import { db } from '../firebaseConfig'; // Import db
import { collection, addDoc } from 'firebase/firestore'; // Import Firestore functions

const PaymentStatusPage = () => {
  console.log("PaymentStatusPage component is rendering."); // ADDED FOR DEBUGGING
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const transactionId = searchParams.get('id');
  // const encodedBookingData = searchParams.get('bookingData'); // Removed
  const [status, setStatus] = useState('Cargando...');
  const [message, setMessage] = useState('Verificando el estado de tu pago...');
  const [transactionDetails, setTransactionDetails] = useState(null);
  const [bookingSaved, setBookingSaved] = useState(false); // To prevent saving multiple times

  // Function to save booking details to Firestore
  const saveBookingToFirestore = useCallback(async (bookingData) => {
    console.log("Attempting to save booking to Firestore from PaymentStatusPage:", bookingData);
    try {
      await addDoc(collection(db, "promotionBookings"), bookingData);
      console.log("Booking saved to Firestore successfully from PaymentStatusPage!");
      setBookingSaved(true);
    } catch (e) {
      console.error("Error adding document to Firestore from PaymentStatusPage: ", e);
      alert("Hubo un error al guardar la reserva. Por favor, contacta a soporte.");
    }
  }, []);

  useEffect(() => {
    console.log("PaymentStatusPage: useEffect running."); // ADDED FOR DEBUGGING
    if (!transactionId) {
      setStatus('Error');
      setMessage('No se encontró ID de transacción.');
      return;
    }

    const verifyPayment = async () => {
      try {
        // Wompi API endpoint for transaction status
        const wompiApiUrl = `https://production.wompi.co/v1/transactions/${transactionId}`;
        
        const response = await fetch(wompiApiUrl);
        const data = await response.json();

        if (response.ok && data.data) {
          setTransactionDetails(data.data);
          if (data.data.status === 'APPROVED') {
            setStatus('Aprobado');
            setMessage('¡Tu pago ha sido aprobado con éxito!');

            // Retrieve booking data from localStorage and save to Firestore
            const storedBookingData = localStorage.getItem('wompiBookingData');
            console.log("PaymentStatusPage: storedBookingData from localStorage", storedBookingData);
            // console.log("PaymentStatusPage: bookingSaved state", bookingSaved); // Removed
            if (storedBookingData && !bookingSaved) {
              const initialBookingData = JSON.parse(storedBookingData);
              const finalBookingData = {
                ...initialBookingData,
                transactionId: data.data.id,
                wompiReference: data.data.reference,
                status: 'approved',
                updatedAt: new Date().toISOString(),
              };
              saveBookingToFirestore(finalBookingData);
              localStorage.removeItem('wompiBookingData'); // Clean up localStorage
            }

          } else if (data.data.status === 'PENDING') {
            setStatus('Pendiente');
            setMessage('Tu pago está pendiente de confirmación.');
          } else if (data.data.status === 'DECLINED') {
            setStatus('Rechazado');
            setMessage('Tu pago ha sido rechazado. Por favor, intenta de nuevo.');

            // Retrieve booking data from localStorage and save to Firestore
            const storedBookingData = localStorage.getItem('wompiBookingData');
            if (storedBookingData && !bookingSaved) {
              const initialBookingData = JSON.parse(storedBookingData);
              const finalBookingData = {
                ...initialBookingData,
                transactionId: data.data.id,
                wompiReference: data.data.reference,
                status: 'declined',
                updatedAt: new Date().toISOString(),
              };
              saveBookingToFirestore(finalBookingData);
              localStorage.removeItem('wompiBookingData'); // Clean up localStorage
            }

          } else {
            setStatus('Desconocido');
            setMessage(`Estado de pago desconocido: ${data.data.status}`);
          }
        } else if (response.status === 404) {
          setStatus('Error');
          setMessage('No se encontró la transacción con el ID proporcionado. Por favor, verifica el ID o contacta a soporte.');
        } else {
          setStatus('Error');
          setMessage(`No se pudo verificar el pago: ${data.message || 'Error desconocido'}`);
        }
      } catch (error) {
        console.error("Error al verificar el pago con Wompi:", error);
        setStatus('Error');
        setMessage('Hubo un problema al verificar tu pago. Por favor, contacta a soporte.');
      }
    };

    verifyPayment();
  }, [transactionId, bookingSaved, saveBookingToFirestore]); // Removed encodedBookingData from dependencies

  const getStatusClass = () => {
    switch (status) {
      case 'Aprobado': return 'status-approved';
      case 'Pendiente': return 'status-pending';
      case 'Rechazado': return 'status-declined';
      case 'Error': return 'status-error';
      default: return '';
    }
  };

  return (
    <div className="payment-status-container">
      <h2 className={`payment-status-title ${getStatusClass()}`}>Estado de tu Pago</h2>
      <p className="payment-status-message">{message}</p>

      {transactionDetails && (
        <div className="transaction-details">
          <h3>Detalles de la Transacción:</h3>
          <p><strong>ID de Transacción:</strong> {transactionDetails.id}</p>
          <p><strong>Referencia:</strong> {transactionDetails.reference}</p>
          <p><strong>Monto:</strong> {transactionDetails.amount_in_cents / 100} {transactionDetails.currency}</p>
          <p><strong>Estado:</strong> {transactionDetails.status}</p>
          {transactionDetails.status_message && <p><strong>Mensaje:</strong> {transactionDetails.status_message}</p>}
          {/* Puedes añadir más detalles aquí si los necesitas */}
        </div>
      )}

      <button onClick={() => navigate('/eventos')} className="back-to-promos-button">
        Volver a Eventos
      </button>
    </div>
  );
};

export default PaymentStatusPage;
